var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "navi-dashboard-user",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_964",
    "data-name": "Path 964",
    d: "M3.342,9.167a.841.841,0,0,0,.8-.6L5.485,4.1A1.67,1.67,0,0,1,8.678,4.09l3.4,11.328,2.133-4.775A2.5,2.5,0,0,1,16.5,9.167H20V2.5A2.5,2.5,0,0,0,17.5,0H2.5A2.5,2.5,0,0,0,0,2.5V9.167Zm0,0",
    fill: "#d6d6d6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_965",
    "data-name": "Path 965",
    d: "M16.5,123.541a.832.832,0,0,0-.763.488L13.6,128.805a1.648,1.648,0,0,1-1.519.986,1.669,1.669,0,0,1-1.594-1.173l-3.4-11.328L5.74,121.764a2.5,2.5,0,0,1-2.4,1.777H0v6.667a2.5,2.5,0,0,0,2.5,2.5h15a2.5,2.5,0,0,0,2.5-2.5v-6.667Zm0,0",
    transform: "translate(0 -112.707)",
    fill: "#d6d6d6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.dd6edfd8caaaa21e6a2c009dd9f4ec2c.svg";
export { ForwardRef as ReactComponent };